import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Logo from "../../assets/assets/Nibss-Logo.png";
import Button3 from "../../components/Button/Button3";
import { getTestCardPaymentDetails } from "../../redux/Actions/TestCardActions";
import { PropTypes } from "prop-types";
const TestPayment = (props) => {
  const { isGetting, getDetails, details } = props;
  const appId = props.location.state && props.location.state.id;
  useEffect(
    () => {
      const payload = {
        product_description: "test_card",
      };
      getDetails(payload);
    },
    // eslint-disable-next-line
    [appId, getDetails]
  );
  const validate = details && Object.keys(details).length === 0;
  const merchantId = details && details.merchant_id;
  const secretKey = details && details.secret_key;
  const productId = details && details.product_id;
  const productDesc = details && details.product_description;
  const amount = details && details.amount;
  const formattedAmount = Number(amount) / 100;
  const currency = details && details.currency;
  const transactionId = details && details.transaction_id;
  const responseUrl = details && details.response_url;
  const hash = details && details.hash;

  const paymentUrl = details && details.payment_url;

  function addCommas(x) {
    var parts = x.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  }
  return (
    <div className="application">
      <Link to="/">
        {" "}
        <div className="application-logo">
          <img src={Logo} alt="Nibss" />
        </div>
      </Link>
      <div className="payment-device">
        <h1>Purchasing Test Card...</h1>
        <p>
          Congratulations! You are one step closer to completing <br /> your
          payment
        </p>
        <div className="payment-start-form">
          <div className="top">
            <div className="title">Product Description</div>
            <input
              type="text"
              placeholder="Enter product description"
              value="Test Card"
              readOnly
            />
          </div>
          <div className="payment-start-check">
            <div className="pay-amount">
              <h4>Payment Amount</h4>
              <h5>
                {isGetting
                  ? "......"
                  : formattedAmount
                  ? `N${addCommas(formattedAmount)}`
                  : "Nil"}
              </h5>
            </div>
          </div>
          <form
            name="form1"
            id="form1"
            action={paymentUrl}
            method="post"
            className="form"
          >
            <input
              type="hidden"
              name="merchant_id"
              id="merchant_id"
              value={merchantId}
              readOnly="readonly"
            />
            <input
              type="hidden"
              name="secretkey"
              id="secretkey"
              value={secretKey}
              readOnly="readonly"
            />
            <input
              type="hidden"
              name="product_id"
              id="product_id"
              value={productId}
            />
            <input
              type="hidden"
              name="product_description"
              id="product_description"
              value={productDesc}
            />
            <input type="hidden" name="amount" id="amount" value={amount} />
            <input
              type="hidden"
              name="currency"
              id="currency"
              value={currency}
            />
            <input
              type="hidden"
              name="transaction_id"
              id="transaction_id"
              value={transactionId}
            />
            <input
              type="hidden"
              name="response_url"
              id="response_url"
              value={responseUrl}
            />
            <input type="hidden" name="hash" id="hash" value={hash} />
            <Button3
              width="100%"
              height="58px"
              word={"MAKE PAYMENT"}
              disabled={isGetting || validate}
              type="submit"
            />
          </form>
        </div>
      </div>
    </div>
  );
};
const mapDispatchToProps = (dispatch) => ({
  getDetails: (payload) => dispatch(getTestCardPaymentDetails(payload)),
});
const mapStateToProps = (state) => {
  return {
    isGetting: state.test.isGettingTestDetails,
    details: state.test.testCardPaymentDetails,
  };
};
TestPayment.propTypes = {
  details: PropTypes.object,
  getDetails: PropTypes.func,
  isGetting: PropTypes.bool,
  location: PropTypes.shape({
    state: PropTypes.shape({
      id: PropTypes.number,
    }),
  }),
  props: PropTypes.object,
};
export default connect(mapStateToProps, mapDispatchToProps)(TestPayment);